module.exports = __webpack_public_path__ + "static/media/thankynote-ui-design.f42481cb.jpg";